import axios from "../javascript/custom-axios";
let RESOURCE_NAME = "adminReport";

export default {
  /**
   * Get filtered admin reports.
   * @param {{ Page: number, PageSize: number, Name: string, CompanyCategory: string }} params
   * @returns {Promise<any>}
   */
  getAll(params) {
    return axios.get(`${RESOURCE_NAME}/get`, { params });
  },

  /**
   * Add a new admin report.
   * @param {{ Id: string, SQL: string, Name: string, CompanyCategory: number }} data
   * @returns {Promise<any>}
   */
  add(data) {
    return axios.post(`${RESOURCE_NAME}/add`, data);
  },

  /**
   * Update an existing admin report.
   * @param {{ Id: string, SQL: string, Name: string, CompanyCategory: number }} data
   * @returns {Promise<any>}
   */
  update(data) {
    return axios.put(`${RESOURCE_NAME}/update`, data);
  },

  /**
   * Delete an admin report.
   * @param {string} id
   * @returns {Promise<any>}
   */
  delete(id) {
    return axios.delete(`${RESOURCE_NAME}/delete?Id=${id}`);
  },

  /**
   * Get view headers.
   * @returns {Promise<any>}
   */
  getViewHeaders() {
    return axios.get(`${RESOURCE_NAME}/getViewHeaders`);
  },

  /**
   * Get report results.
   * @param {{ ReportId: string, Page: number, PageSize: number }} params
   * @returns {Promise<any>}
   */
  getReportResults(params) {
    return axios.get(`${RESOURCE_NAME}/getReportResults`, {
      params,
    });
  },

  /**
   * Get SQL results.
   * @param {{ Page: number, PageSize: number, SQL: string }} params
   * @returns {Promise<any>}
   */
  getSqlResults(params) {
    return axios.get(`${RESOURCE_NAME}/getSqlResults`, {
      params,
    });
  },

  /**
   * Download Excel file.
   * @param {string} params
   * @returns {Promise<any>}
   */
  downloadExcels(params) {
    return axios.get(`${RESOURCE_NAME}/download-excels`, {
      params,
      responseType: "blob",
    });
  },
};
